import { useTranslation } from "react-i18next";
import type { AssetClass, ClassRow } from "../../lib/networth";

interface Props {
  assetClass: AssetClass;
  row: ClassRow;
}

function formatEur(cents: number): string {
  return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}

export function AssetClassRow({ assetClass, row }: Props) {
  const { t } = useTranslation();
  return (
    <tr className="border-b">
      <td className="p-2">{t(`networth.assetClass.${assetClass}`)}</td>
      <td className="p-2 text-right font-mono">{formatEur(row.valueCents)}</td>
      <td className="p-2">
        <span
          className={
            row.source === "DERIVED"
              ? "px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded"
              : "px-2 py-0.5 text-xs bg-amber-100 text-amber-700 rounded"
          }
        >
          {t(`networth.source.${row.source}`)}
        </span>
      </td>
      <td className="p-2 text-gray-600 text-sm">{row.note ?? "—"}</td>
    </tr>
  );
}
